import { SET_OCCASIONS_LIST, LOGOUT } from "../actions/types";

const INITIAL_STATE = {
    list: []
};

const occasionsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_OCCASIONS_LIST:
            return {
                ...state,
                list: action.payload.map(occasion => {
                    return {
                        occasionID: occasion.occasionID,
                        occasionName: occasion.occasionName
                    };
                })
            };
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default occasionsReducer;